module.exports = "<div class=\"articlePageImageContainer\">\n    <div id=\"articlePageArticleImagesImage--1\" class=\"articlePageImageItem\">\n    </div>\n    <div id=\"articlePageArticleImagesImage--2\" class=\"articlePageImageItem\">\n    </div>\n    <div id=\"articlePageArticleImagesImage--3\" class=\"articlePageImageItem\">\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/imageSection/imageSection.component.html
// module id = ../../../../../src/app/components/imageSection/imageSection.component.html
// module chunks = main